import { ServiceContractPresenter } from '@shared/modules/service-contracts/service-contract.presenter';
import { TeamPresenter } from '@shared/modules/teams/team-presenter';
import { UserPresenter } from '@shared/modules/users/user.presenter';
import { mapMarkerForPerson } from '../maps';
import { BelongsToPersonPresenter } from '../people/person.presenter';
import type { Client } from './client';
import Icon = google.maps.Icon/**/;

export class ClientPresenter extends BelongsToPersonPresenter<Client> {

    get defaultTeam(): TeamPresenter {
        return this.present('default_team.data', TeamPresenter);
    }

    get teams(): TeamPresenter[] {
        return this.present('teams.data', TeamPresenter);
    }

    get teamNames(): string[] {
        return this._get('teamNames', () => this.teams.map(team => team.name));
    }

    get activeContracts(): ServiceContractPresenter[] {
        return this.presentCollection('active_service_contracts.data', ServiceContractPresenter);
    }

    get serviceContracts(): ServiceContractPresenter[] {
        return this.presentCollection('service_contracts.data', ServiceContractPresenter);
    }

    get nextClient(): ClientPresenter {
        return this.present('next_client.data', ClientPresenter);
    }

    get previousClient(): ClientPresenter {
        return this.present('previous_client.data', ClientPresenter);
    }

    get mapMarkerIcon(): Icon {
        return this._get('mapMarkerIcon', () => mapMarkerForPerson('client', this.data.person.data.gender));
    }

    get phone(): string {
        return this._get('phone', () => this.person.data.tel_home ?? this.person.data.tel_mobile ?? this.person.data.tel_work);
    }

    get status(): { icon?: string; text?: string; tooltip: string } {
        return this._get('status', () => {
            if (this.data.is_suspended) {
                return {
                    icon: 'error_outline',
                    tooltip: 'Temporarily Suspended'
                };
            }

            if (this.data.has_active_service_contract) {
                return {
                    icon: 'check_circle',
                    tooltip: 'Active'
                };
            }

            if (this.data.has_pending_service_contract) {
                return {
                    icon: 'schedule',
                    tooltip: 'Pending'
                };
            }

            if (!this.data.has_active_service_contract && this.data.finish_date) {
                return {
                    text: 'Finished',
                    tooltip: this.formatDateTimeReadable(this.toDateTime('finish_date', false))
                };
            }
        });
    }

    get createdBy(): UserPresenter {
        return this.present('created_by.data', UserPresenter);
    }
}
